import React from "react";
import { IProduct } from "../../../api/Admin/dbProductsApi";
import {
  DataGrid,
  GridColDef,
  GridRenderCellParams,
  GridToolbar,
} from "@mui/x-data-grid";
import { useDataGridStyles } from "../../../hooks/useDataGridStyles";
import { Link, Grid, Avatar, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";
import { format } from "date-fns";

//https://devexpress.github.io/devextreme-reactive/react/grid/demos/featured/tree-data/

export interface IProductsGridProps {
  products: IProduct[];
  selectionChanged: (row: IProduct) => void;
}

const AdminProductsGrid: React.FC<IProductsGridProps> = ({
  products,
  selectionChanged,
}) => {
  const StyledAvatar = styled(Avatar)(() => ({
    width: "34px",
    height: "34px",
  }));

  const StyledPurpleAvatar = styled(Avatar)(({ theme }) => ({
    backgroundColor: theme.palette.primary.main,
    width: "34px",
    height: "34px",
  }));

  const StyledProductNameLink = styled(Link)(() => ({
    margin: "0 0 0 12px",
  }));

  const { styles } = useDataGridStyles({
    variant: "common",
    type: "purchases",
  });

  const columns: GridColDef[] = [
    {
      field: "productName",
      headerName: "Product Name",
      width: 400,
      renderCell: (params: GridRenderCellParams) => {
        const row = params.row;
        return (
          <Grid
            container
            direction="row"
            justifyContent="flex-start"
            alignItems="center"
          >
            {row.isCommercial ? (
              <StyledPurpleAvatar>C</StyledPurpleAvatar>
            ) : (
              <StyledAvatar>NC</StyledAvatar>
            )}
            <StyledProductNameLink
              href="#"
              variant="inherit"
              onClick={() => selectionChanged(row)}
              sx={{ textDecoration: "none" }}
            >
              {row.productName}
            </StyledProductNameLink>
          </Grid>
        );
      },
    },
    {
      field: "lastUpdate",
      headerName: "Last Update",
      width: 180,
      renderCell: (params: GridRenderCellParams) => (
        params.row.lastUpdate ? format(new Date(params.row.lastUpdate), "dd/MM/yyyy") : ""
      ),
    },
    {
      field: "isCommercial",
      headerName: "Type",
      width: 180,
      renderCell: (params: GridRenderCellParams) => (
        <Typography>
          {params.row.isCommercial ? "Commercial" : "Custom"}
        </Typography>
      ),
    },
  ];

  return (
    <div style={{ height: "80%", width: "100%" }}>
      <DataGrid
        rows={products}
        columns={columns}
        getRowId={(row) => row.productId}
        initialState={{
          pagination: {
            paginationModel: { page: 0, pageSize: 100 },
          },
        }}
        sx={styles}
        pageSizeOptions={[10, 25, 50, 100]}
        disableRowSelectionOnClick
        slots={{ toolbar: GridToolbar }}
        slotProps={{
          toolbar: {
            showQuickFilter: true,
            quickFilterProps: { debounceMs: 500 },
          },
        }}
      />
    </div>
  );
};

export default AdminProductsGrid;
